import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import NewQuotationPage from './pages/NewQuotationPage';
import ListQuotationPage from './pages/ListQuotationPage';
import EditQuotationPage from './pages/EditQuotationPage'; // ✅ NEW

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/new-quotation"
          element={<PrivateRoute><NewQuotationPage /></PrivateRoute>}
        />
        <Route
          path="/list-quotation"
          element={<PrivateRoute><ListQuotationPage /></PrivateRoute>}
        />
        {/* ✅ New edit route */}
        <Route
          path="/edit-quotation/:id"
          element={<PrivateRoute><EditQuotationPage /></PrivateRoute>}
        />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
